import React, { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import DocumentMeta from "react-document-meta";
import renderHtml from "react-render-html";
import { useParams, useHistory } from "react-router-dom";
import HeaderBanner from "../Components/HeaderBanner";
import Config from "../config.json";
import ContextComponent from "../Context";
import Loading from "./Loading";
import Product from "../Images/product.png";
import Statics from "../Statics";
import HelpSidebar from "./HelpSidebar";
import HelpSearchBox from "../Components/HelpSearchBox";

const body = (
  <p>
    برای آموزش استفاده و کار با نرم افزار پژوهیار می‌توانید از محتواهای این بخش
    استفاده کنید.
    <br /> برای سایر بخش‌های پژوهیار راهنمای بیشتر و فیلم‌های آموزشی تهیه شده
    است.
  </p>
);

const title = "راهنمای آموزش";

const page_meta = {
  language: "fa",
  copyright: "پژوهیار",
  description: "نرم‌افزار استناددهی",
  title: Config.title + " | آموزش",
  meta: {
    charset: "utf-8",
    name: {
      keywords: "پژوهیار",
    },
  },
};

const Help = () => {
  const context = useContext(ContextComponent);
  const { helpPost_id } = useParams();
  const [allHelps, set_allHelps] = useState([]);
  const navigate = useHistory();
  // eslint-disable-next-line
  const [searchedHelps, setSearchedHelps] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loadingState, setLoadingState] = useState(Statics.NOT_LOADED);

  const item = allHelps.find(item => item.id === parseInt(helpPost_id));
  useEffect(() => {
    if (item) {
      navigate.push(`/help/${formatTitle(item.title)}`, { replace: true });
    }
  }, [item, navigate]);

  const getHelpCategories = () => {
    const storedCategories = sessionStorage.getItem("categories");

    if (storedCategories) {
      setCategories(JSON.parse(storedCategories));
    } else {
      context.ApiDriver.getHelpCategories(
        {
          parent_id: 0,
        },
        data => {
          setCategories(data.data);
          sessionStorage.setItem("categories", JSON.stringify(data.data));
        },
        error => {
          console.log(error);
        },
      );
    }
  };
  const getAllHelpPosts = () => {
    setLoadingState(Statics.LOADING);
    const storedHelps = sessionStorage.getItem("allHelps");

    if (storedHelps) {
      const parsedHelps = JSON.parse(storedHelps);
      set_allHelps(parsedHelps);
      setLoadingState(Statics.LOADED);
    } else {
      context.ApiDriver.getHelp(
        {
          page_size: 1000,
        },
        data => {
          set_allHelps(data.data);
          sessionStorage.setItem("allHelps", JSON.stringify(data.data));
          setLoadingState(Statics.LOADED);
        },
        error => {
          console.log(error);
          setLoadingState(Statics.CAUSED_ERROR);
        },
      );
    }
  };

  useEffect(getAllHelpPosts, [context.query_parameters["search_term"]]);
  useEffect(getAllHelpPosts, []);
  useEffect(getHelpCategories, [helpPost_id]);
  useEffect(getHelpCategories, []);

  if (helpPost_id) {
    var targetTitle = helpPost_id.replace(/_/g, " ").replace(/--/g, "‌");
  }
  const foundhelp = [allHelps.find(help => help.title === targetTitle)];
  const formatTitle = title => {
    return title.replace(/\s+/g, "_").replace(/\u200C/g, "--");
  };

  return (
    <DocumentMeta {...page_meta}>
      <HeaderBanner
        body={body}
        title={title}
        image={Product}
        header_color="#cecbfa"
      />
      <Row
        className="help-section w-100 mx-0 p-5"
        style={{ background: "#eee" }}>
        <Col
          md={3}
          sm={12}
          style={{ paddingTop: "10px", paddingBottom: "10px" }}>
          <HelpSearchBox helps={allHelps} setSearchedHelps={setSearchedHelps} />
          <HelpSidebar sidebar_title="دسته بندی راهنما" data={categories} />
        </Col>
        <Col
          md={9}
          sm={12}
          style={{ paddingTop: "10px", paddingBottom: "10px" }}>
          {loadingState === Statics.NOT_LOADED ? "بارگذاری نشده" : null}
          {loadingState === Statics.CAUSED_ERROR ? (
            <div className="error-parent">
              <p>ارتباط با سرور با مشکل مواجه شد !</p>
              <img
                className="error-img"
                src="images/errorPic.webp"
                width="200px"
                alt="error-png"
              />
            </div>
          ) : null}
          {loadingState === Statics.LOADING ? (
            <div className="loading">
              <Loading />
            </div>
          ) : null}
          {loadingState === Statics.LOADED ? (
            <>
              <h3 className="post-category-title">
                راهنما >{" "}
                {foundhelp[0]
                  ? foundhelp[0].category.title + " > " + foundhelp[0].title
                  : null}
              </h3>
              <div className="post-content">
                {foundhelp[0] ? (
                  <>
                    <div style={{ paddingTop: "20px", textAlign: "right" }}>
                      <h3>{foundhelp ? foundhelp[0].title : null}</h3>
                    </div>
                    <div
                      style={{ paddingTop: "50px", direction: "rtl" }}
                      className="outbox-content">
                      {foundhelp ? renderHtml(foundhelp[0].body) : null}
                    </div>
                  </>
                ) : (
                  "برای نمایش راهنمای پژوهیار از منو ی سمت چپ عنوان مور نظر را انتخاب کنید"
                )}
              </div>
            </>
          ) : null}
        </Col>
      </Row>
    </DocumentMeta>
  );
};

export default Help;
